/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Pairing_Broker_UnpairedInputs */

const cs_ebr_pairing_broker_unpaired = /** @type {(inputs: Ebr_Pairing_Broker_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bez makléře`)
};

const en_ebr_pairing_broker_unpaired = /** @type {(inputs: Ebr_Pairing_Broker_UnpairedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no broker`)
};

/**
* | output |
* | --- |
* | "no broker" |
*
* @param {Ebr_Pairing_Broker_UnpairedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_pairing_broker_unpaired = /** @type {((inputs?: Ebr_Pairing_Broker_UnpairedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Pairing_Broker_UnpairedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_pairing_broker_unpaired(inputs)
	return cs_ebr_pairing_broker_unpaired(inputs)
});